<template>
    <div id="app">
        <nav-header></nav-header>
        <router-view style="flex: 1" />
        <!-- <div class="footer-box">
            <div>
                <img src="images/logo-pku.png" height="40" />
                <img src="images/logo-pku.png" height="40" />
            </div>
            <div>Copyright © 2021-2023. College of Future Technology (CFT),</div>
            <div>Peking University. All Rights Reserved.</div>
        </div> -->
    </div>
</template>

<script>
import navHeader from "@/components/nav-header";
export default {
    components: { navHeader },
};
</script>

<style lang="less">
.footer-box {
    height: 180px;
    background: #8d8d8d;
    border-top: 1px solid #e5e5e5;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 30px 0;

    img {
        padding: 0 5px;
    }
}

html,
body {
    height: 100%;
    margin: 0;
}

a {
    cursor: pointer;
    text-decoration: none;
    color: inherit;
}

.tableT {
    font-size: 24px;
    font-weight: bold;
}


.header-tool {
    display: flex;
    align-items: center;
    justify-content: flex-end;
}

.search-input {
    display: inline-block;
    width: 200px !important;
}

.el-table__cell {
    color: black;
}

#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    min-width: 1440px;
    display: flex;
    height: 100%;
    flex-direction: column;

}

.table {
    header {
        tr {
            th {
                background-color: #F2F2F2;
                font-size: 18px;
                color: #176B6E;
            }
        }
    }
}

#nav {
    padding: 30px;

    a {
        font-weight: bold;
        color: #2c3e50;

        &.router-link-exact-active {
            color: #42b983;
        }
    }
}
</style>
